import React from 'react';
import ReactDOM from 'react-dom';
/* import root component */
import App from './App';
/* css and bootstrap */
import '../src/nprogress.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render( < App/> , document.getElementById('root'));
registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js